import { Col, Container, Row } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer id="site-footer">
                <Container>
                    <Row>
                        <Col md={4}>
                            <div className="footer-logo mb-4">
                                <Link to="/">
                                    <img src="assets/images/rsslogo.png" height="70px" alt="logo" />
                                </Link>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="footer-links">
                                <ul>
                                    <li>
                                        <NavLink to="/">Home</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/about">About</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/projects">Projects</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/gallery">Gallery</NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/contact">Contact Us</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="social-network mb-4">
                                <Link className="facebook" to="https://www.facebook.com" target="_blank">
                                    <i className="fab fa-facebook-f"></i>
                                </Link>
                                <Link className="linkedin" to="https://www.linkedin.com" target="_blank">
                                    <i className="fab fa-linkedin-in"></i>
                                </Link>
                                <Link className="twitter" to="https://twitter.com" target="_blank">
                                    <i className="fab fa-twitter"></i>
                                </Link>
                                <Link className="instagram" to="https://www.instagram.com/" target="_blank">
                                    <i className="fab fa-instagram"></i>
                                </Link>
                            </div>
                            <div className="para-txt txt-small txt-clr-white copyright">
                                <p className="m-0">Copyright 2021 | All rights reserved By RSS</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    )
}
export default Footer;